import * as React from "react";
import { utilIcons } from "../../../utils/utilIcons";
import { Icon } from "./Icon";
export var InnerIcon = React.memo(function (_a) {
    var styleId = _a.styleId, children = _a.children, icon = _a.icon;
    if (!icon) {
        return React.createElement(React.Fragment, null, children);
    }
    var smallerSize = utilIcons.previousIconSize(styleId);
    return (React.createElement("div", { className: "w100 h100 flex flex--guts" },
        React.createElement(Icon, { styleId: smallerSize, icon: icon }, children)));
});



//////////////////
// WEBPACK FOOTER
// ./src/features/generic/icon/InnerIcon.tsx
// module id = 667
// module chunks = 3